var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "user-face-container" }, [
    _c("img", {
      staticClass: "user-face",
      attrs: { src: _vm.faceSrc, srcset: _vm.faceSrcset },
    }),
    _vm._v(" "),
    _c("img", {
      staticClass: "user-pendant",
      attrs: { src: _vm.pendantSrc, srcset: _vm.pendantSrcset },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }